import { j as n, c as f } from "../../utils-BdNIfrGQ.js";
import * as u from "react";
import { c as I } from "../../index-UQQE3dtT.js";
import { P as p } from "../../index-oiSd2zY3.js";
import { c as R } from "../../index-Di82Y7n3.js";
import { n as V } from "../../normalize-spacing-DY0KSpr_.js";
var c = "Progress", d = 100, [j] = I(c), [E, _] = j(c), v = u.forwardRef(
  (r, e) => {
    const {
      __scopeProgress: t,
      value: a = null,
      max: s,
      getValueLabel: w = M,
      ...y
    } = r;
    (s || s === 0) && !m(s) && console.error(k(`${s}`, "Progress"));
    const o = m(s) ? s : d;
    a !== null && !g(a, o) && console.error(A(`${a}`, "Progress"));
    const i = g(a, o) ? a : null, $ = l(i) ? w(i, o) : void 0;
    return /* @__PURE__ */ n.jsx(E, { scope: t, value: i, max: o, children: /* @__PURE__ */ n.jsx(
      p.div,
      {
        "aria-valuemax": o,
        "aria-valuemin": 0,
        "aria-valuenow": l(i) ? i : void 0,
        "aria-valuetext": $,
        role: "progressbar",
        "data-state": P(i, o),
        "data-value": i ?? void 0,
        "data-max": o,
        ...y,
        ref: e
      }
    ) });
  }
);
v.displayName = c;
var x = "ProgressIndicator", N = u.forwardRef(
  (r, e) => {
    const { __scopeProgress: t, ...a } = r, s = _(x, t);
    return /* @__PURE__ */ n.jsx(
      p.div,
      {
        "data-state": P(s.value, s.max),
        "data-value": s.value ?? void 0,
        "data-max": s.max,
        ...a,
        ref: e
      }
    );
  }
);
N.displayName = x;
function M(r, e) {
  return `${Math.round(r / e * 100)}%`;
}
function P(r, e) {
  return r == null ? "indeterminate" : r === e ? "complete" : "loading";
}
function l(r) {
  return typeof r == "number";
}
function m(r) {
  return l(r) && !isNaN(r) && r > 0;
}
function g(r, e) {
  return l(r) && !isNaN(r) && r <= e && r >= 0;
}
function k(r, e) {
  return `Invalid prop \`max\` of value \`${r}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${d}\`.`;
}
function A(r, e) {
  return `Invalid prop \`value\` of value \`${r}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${d} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var b = v, S = N;
const h = u.forwardRef(({ className: r, value: e, ...t }, a) => /* @__PURE__ */ n.jsx(
  b,
  {
    ref: a,
    className: f("relative w-full overflow-hidden", r),
    ...t,
    children: /* @__PURE__ */ n.jsx(
      S,
      {
        className: "h-full w-full flex-1 transition-all",
        style: { transform: `translateX(-${100 - (e || 0)}%)` }
      }
    )
  }
));
h.displayName = b.displayName;
const z = {
  default: "h-5",
  thin: "h-4"
}, C = R("shadow rounded-lg", {
  variants: {
    color: {
      primary: "bg-primary-light/40 text-primary-dark",
      success: "bg-success-light/40 text-success-dark",
      warning: "bg-warning-light/40 text-warning-dark",
      info: "bg-info-light/40 text-info-dark",
      destructive: "bg-destructive-light/40 text-destructive-dark"
    },
    size: z
  },
  defaultVariants: {
    color: "success",
    size: "default"
  },
  compoundVariants: [
    {
      color: "primary",
      className: "*:bg-primary"
    },
    {
      color: "success",
      className: "*:bg-success"
    },
    {
      color: "info",
      className: "*:bg-info"
    },
    {
      color: "warning",
      className: "*:bg-warning"
    },
    {
      color: "destructive",
      className: "*:bg-destructive"
    }
  ]
}), D = ({
  color: r = "success",
  size: e = "default",
  value: t,
  spacing: a
}) => /* @__PURE__ */ n.jsx(
  h,
  {
    value: t,
    className: f(C({ color: r, size: e }), V(a))
  }
);
D.displayName = "Progress bar";
export {
  D as default
};
